<template>
  <div v-if="userInfo" class="profile-html">
    <div class="profileBox intro-x">
      <div class="profileLeft1 test">
        <div class="header1">
          <h2 class="text-lg font-medium truncate">我的资料</h2>
          <div class="switchRight">
            <el-switch v-model="is_Switch" inactive-text="隐私保护"></el-switch>
          </div>
        </div>
        <div class="infoDiv">
          <div class="headDiv">
            <div class="touXiang" @click="isTouXiang = !isTouXiang">
              <img
                class="touXiang1"
                :src="
                  userInfo.avatar ||
                  'http://osssys.izhyin.cn/9_avatar.png?1610590122'
                "
                alt=""
              />

              <img class="jiaobiao" src="@/assets/images/jiaobiao.png" alt="" />
            </div>
            <div class="headName">
              <p style="color: #333333; font-size: 16px">
                {{ userInfo.nickname || "会员昵称" }}
              </p>
              <p style="color: #718096; font-size: 14px">
                会员ID：{{ userInfo.uid }}
              </p>
            </div>
          </div>
          <div class="headDiv2">
            <p>
              <img src="@/assets/images/min-home.png" alt="" />
              <font style="font-size: 14px; color: #718096">
                <span style="letter-spacing: 4px">现居地</span>：</font
              >
              <span style="color: #2c2c2c; font-size: 14px">{{
                userInfo.id_area || "未绑定"
              }}</span>
            </p>
            <p style="margin: 2px 0">
              <img src="@/assets/images/min-my.png" alt="" />
              <font style="font-size: 14px; color: #718096"
                ><span style="letter-spacing: 12.6px">性别</span>：</font
              >
              <span style="color: #2c2c2c; font-size: 14px">{{
                userInfo.id_gender === "0"
                  ? "女"
                  : userInfo.id_gender === "1"
                  ? "男"
                  : "未绑定"
              }}</span>
            </p>
            <p>
              <img src="@/assets/images/min-rili.png" alt="" />
              <font style="font-size: 14px; color: #718096"
                ><span style="letter-spacing: 12.6px">生日</span>：</font
              >
              <span style="color: #2c2c2c; font-size: 14px">{{
                userInfo.id_birth
              }}</span>
            </p>
          </div>

          <div class="headDiv3">
            <p>
              <img src="@/assets/images/min-anquan.png" alt="" />
              <font style="font-size: 14px; color: #718096">企业认证：</font>
              <span
                v-if="userInfo.company_name"
                style="color: #2c2c2c; font-size: 14px; margin-right: 10px"
                >{{ userInfo.company_name }}</span
              >
              <span class="amendClass" @click="isEnterprise = !isEnterprise">{{
                userInfo.company_name ? "修改" : "未绑定"
              }}</span>
            </p>

            <p>
              <img src="@/assets/images/min-renzheng.png" alt="" />
              <font style="font-size: 14px; color: #718096">实名认证：</font>

              <span
                v-if="userInfo.name && is_Switch"
                style="color: #2c2c2c; font-size: 14px; margin-right: 10px"
                >****</span
              >

              <span
                style="color: #2c2c2c; font-size: 14px; margin-right: 10px"
                v-else-if="userInfo.name"
                >{{ userInfo.name }}</span
              >

              <span class="amendClass" @click="isIdCard = !isIdCard">{{
                userInfo.name ? "修改" : "未绑定"
              }}</span>
            </p>
            <p>
              <img src="@/assets/images/min-phone.png" alt="" />
              <font style="font-size: 14px; color: #718096">手机绑定：</font>

              <span
                v-if="userInfo.phone && is_Switch"
                style="color: #2c2c2c; font-size: 14px; margin-right: 10px"
                >{{ userInfo.phone | phoneFilter }}</span
              >

              <span
                v-else-if="userInfo.phone"
                style="color: #2c2c2c; font-size: 14px; margin-right: 10px"
                >{{ userInfo.phone }}</span
              >

              <span class="amendClass" @click="isPhone = !isPhone">{{
                userInfo.phone ? "修改" : "未绑定"
              }}</span>
            </p>

            <p>
              <img src="@/assets/images/min-zhifubao.png" alt="" />
              <font
                style="
                  font-size: 14px;
                  color: #718096;
                  letter-spacing: 4.6px;
                  display: inline-block;
                  width: 70px;
                "
                >支付宝：</font
              >

              <span
                v-if="userInfo.acc_alipay && is_Switch"
                style="color: #2c2c2c; font-size: 14px; margin-right: 10px"
                >{{ userInfo.acc_alipay | phoneFilter }}</span
              >

              <span
                v-else-if="userInfo.acc_alipay"
                style="color: #2c2c2c; font-size: 14px; margin-right: 10px"
                >{{ userInfo.acc_alipay }}</span
              >

              <span class="amendClass" @click="isAcc_alipay = !isAcc_alipay">{{
                userInfo.acc_alipay ? "修改" : "未绑定"
              }}</span>
            </p>

            <p>
              <img src="@/assets/images/min-weixin.png" alt="" />
              <font style="font-size: 14px; color: #718096">微信绑定：</font>
              <span
                v-if="userInfo.acc_wx_id && is_Switch"
                style="color: #2c2c2c; font-size: 14px; margin-right: 10px"
                >****</span
              >
              <span
                v-else-if="userInfo.acc_wx_id"
                style="color: #2c2c2c; font-size: 14px; margin-right: 10px"
              >
                {{ userInfo.acc_wx_id }}
              </span>
              <span class="amendClass" @click="isAccWxId = !isAccWxId">{{
                userInfo.acc_wx_id ? "修改" : "未绑定"
              }}</span>
              <span
                v-show="false"
                style="
                  color: #1890ff;
                  font-size: 14px;
                  margin-left: 10px;
                  cursor: pointer;
                "
                >修改</span
              >
            </p>

            <p>
              <img src="@/assets/images/min-youxiang.png" alt="" />
              <font style="font-size: 14px; color: #718096">邮箱绑定：</font>

              <span
                v-if="userInfo.email && is_Switch"
                style="color: #2c2c2c; font-size: 14px; margin-right: 10px"
                >{{ userInfo.email | emailFilter }}</span
              >
              <span
                v-else-if="userInfo.email"
                style="color: #2c2c2c; font-size: 14px; margin-right: 10px"
                >{{ userInfo.email }}</span
              >

              <span class="amendClass" @click="isEmail = !isEmail">{{
                userInfo.email ? "修改" : "未绑定"
              }}</span>
            </p>
            <p>
              <img src="@/assets/images/min-mima.png" alt="" />
              <font style="font-size: 14px; color: #718096">支付密码：</font>

              <span
                v-if="userInfo.passcode"
                style="color: #2c2c2c; font-size: 14px; margin-right: 10px"
                >已设置</span
              >

              <span class="amendClass" @click="isPassword = !isPassword">{{
                userInfo.passcode ? "修改" : "未设置"
              }}</span>
            </p>
			
			<p style="overflow: hidden;display: flex;align-items: center;">
			  <img src="@/assets/images/min-anquan.png" alt="" />
			  <font style="font-size: 14px; color: #718096">技术支持描述：</font>
			
			  <span
			    v-if="userInfo.technical_support_desc"
			    style="color: #2c2c2c; font-size: 14px;margin-right: 10px;overflow: hidden;text-overflow:ellipsis;white-space:nowrap;max-width: 140px;display: inline-block;"
			    >{{userInfo.technical_support_desc}}</span
			  >
			
			  <span class="amendClass" @click="isTech = !isTech">{{
				  userInfo.technical_support_desc ? "修改" : "设置"
			  }}</span>
			</p>
          </div>

          <div class="headDiv4 intro-x" style="overflow: hidden">
            <span class="span" @click="getUserInfo">查看详情</span>
          </div>

          <div class="profileLeft2 conceal-a">
            <div class="div1">
              <div class="header2">我的等级</div>
              <div class="div1">
                <div class="infoBgPng">
                  <div class="infoHead">
                    <img
                      class="infoHead-img"
                      src="@/assets/images/min-zuanshi.png"
                      alt=""
                    />
                    <div class="div-p">
                      <p>
                        成长值
                        {{ growthValue }}
                      </p>
                      <p>
                        <el-progress
                          :stroke-width="3"
                          :percentage="growthValue"
                          color="#FFF"
                        ></el-progress>
                      </p>
                    </div>
                    <img
                      class="xinpian"
                      src="@/assets/images/xinpian.png"
                      alt=""
                    />
                  </div>

                  <div class="infoName">{{ discount.name }}</div>
                  <div v-if="userInfo" class="infoID">
                    ID：{{ userInfo.uid }}

                    <img
                      class="kaiguan"
                      src="@/assets/images/kaiguan.png"
                      alt=""
                    />
                  </div>
                </div>
                <div class="list">
                  <p>推广佣金比例</p>
                  <p v-if="discount.promo_commission_rate">
                    {{ discount.promo_commission_rate }}%
                  </p>
                  <p
                    v-else
                    style="
                      color: #999999;
                      font-size: 14px;
                      line-height: 23px;
                      margin-right: 10px;
                    "
                  >
                    请获取优惠码
                  </p>
                  <el-popover
                    placement="top-start"
                    width="200"
                    trigger="hover"
                    content="被推荐人在智莺系统购买应用时，使用专属邀请码，推荐人可获付款金额*推广佣金比例的推荐奖励"
                  >
                    <div class="tb" slot="reference">?</div>
                  </el-popover>
                </div>
                <div class="list">
                  <p>优惠码折扣</p>
                  <p v-if="userInfo.discount.discount_code_rate">
                    {{ userInfo.discount.discount_code_rate * 1 }}折
                  </p>
                  <p
                    v-else
                    style="
                      color: #999999;
                      font-size: 14px;
                      line-height: 23px;
                      margin-right: 10px;
                    "
                  >
                    请获取优惠码
                  </p>
                  <el-popover
                    placement="top-start"
                    width="200"
                    trigger="hover"
                    content="推荐其他用户在智莺系统购买应用时，使用专属邀请码，被推荐人可以享受优惠折扣"
                  >
                    <div class="tb" slot="reference">?</div>
                  </el-popover>
                </div>
                <!--                <div class="infoButtom-box">-->
                <!--                  <div style="margin-bottom: 20px">-->
                <!--                    <span>推广佣金比例</span>-->
                <!--                    <span-->
                <!--                      class="wenhao"-->
                <!--                      style="float: right; font-size: 20px; color: #1890ff"-->
                <!--                      >{{ discount.promo_commission_rate }}%</span-->
                <!--                    >-->
                <!--                  </div>-->
                <!--                  <div>-->
                <!--                    <span>优惠码折扣</span>-->
                <!--                    <span-->
                <!--                      class="wenhao"-->
                <!--                      style="float: right; font-size: 20px; color: #1890ff;"-->
                <!--                      >{{ discount.coupon_discount }}折</span-->
                <!--                    >-->
                <!--                  </div>-->
                <!--                </div>-->
                <div class="buttomTitle">升到更高等级享受更高优惠</div>
              </div>
            </div>
          </div>
        </div>
        <div class="div2" style="overflow: hidden">
          <div class="xinyongfen1">
            <h1>500</h1>
            <h2>智莺生态信用分</h2>
            <h3>刷新于2020-12-25 17:23</h3>
            <div class="div1">查看详情</div>
          </div>
          <div class="xinyongfen2">
            <el-progress
              type="circle"
              :percentage="50"
              :stroke-width="10"
              :format="format"
              :show-text="true"
            ></el-progress>
          </div>
        </div>
      </div>
      <div class="profileLeft2">
        <div class="div1">
          <div class="header2">我的等级</div>
          <div class="div1">
            <div class="infoBgPng">
              <div class="infoHead">
                <img
                  class="infoHead-img"
                  src="@/assets/images/min-zuanshi.png"
                  alt=""
                />
                <div class="div-p">
                  <p>
                    成长值
                    {{ growthValue }}
                  </p>
                  <p>
                    <el-progress
                      :stroke-width="3"
                      :percentage="growthValue"
                      color="#FFF"
                    ></el-progress>
                  </p>
                </div>
                <img class="xinpian" src="@/assets/images/xinpian.png" alt="" />
              </div>

              <div class="infoName">{{ discount.name }}</div>
              <div v-if="userInfo" class="infoID">
                ID：{{ userInfo.uid }}

                <img class="kaiguan" src="@/assets/images/kaiguan.png" alt="" />
              </div>
            </div>

            <div class="list">
              <p>推广佣金比例</p>
              <p v-if="discount.promo_commission_rate">
                {{ discount.promo_commission_rate }}%
              </p>
              <p
                v-else
                style="
                  color: #999999;
                  font-size: 14px;
                  line-height: 23px;
                  margin-right: 10px;
                "
              >
                请获取优惠码
              </p>
              <el-popover
                placement="top-start"
                width="200"
                trigger="hover"
                content="被推荐人在智莺系统购买应用时，使用专属邀请码，推荐人可获付款金额*推广佣金比例的推荐奖励"
              >
                <div class="tb" slot="reference">?</div>
              </el-popover>
            </div>
            <div class="list">
              <p>优惠码折扣</p>
              <p v-if="discount.discount_code_rate">
                {{ discount.discount_code_rate * 1 }}折
              </p>
              <p
                v-else
                style="
                  color: #999999;
                  font-size: 14px;
                  line-height: 23px;
                  margin-right: 10px;
                "
              >
                请获取优惠码
              </p>
              <el-popover
                placement="top-start"
                width="200"
                trigger="hover"
                content="推荐其他用户在智莺系统购买应用时，使用专属邀请码，被推荐人可以享受优惠折扣"
              >
                <div class="tb" slot="reference">?</div>
              </el-popover>
            </div>

            <div class="buttomTitle">升到更高等级享受更高优惠</div>
          </div>
        </div>
        <div class="div2">
          <div class="header3">
            <div class="title">我的任务</div>
            <a class="flex text-theme-1" @click="getRefresh">
              <RefreshCcwIcon class="icon w-3 h-3 mr-2 mt-1" />
              <span bing>刷新数据</span>
            </a>
          </div>

          <div class="p1">
            <div class="div1">成长值</div>
            <div class="divButtom">
              <h1 style="margin-bottom: 5px">
                <span style="color: #7d8ba0">距离下一等级还有</span>
                <span style="float: right; color: #1890ff"
                  >{{ discount.min_integral }}/
                  {{ discount.max_integral }}</span
                >
              </h1>
              <el-progress
                :percentage="growthValue"
                :stroke-width="4"
              ></el-progress>
            </div>
          </div>
          <div class="p1">
            <div class="div1">任务完成进度</div>
            <div class="divButtom">
              <h1 style="margin-bottom: 5px">
                <span style="color: #7d8ba0">营业额达到10万元</span>
                <span style="float: right; color: #1890ff">0%</span>
              </h1>
              <el-progress :percentage="0" :stroke-width="4"></el-progress>
            </div>

            <div class="divButtom">
              <h1 style="margin-bottom: 5px">
                <span style="color: #7d8ba0">APP用户达到10万人</span>
                <span style="float: right; color: #1890ff">0%</span>
              </h1>
              <el-progress :percentage="0" :stroke-width="4"></el-progress>
            </div>

            <div class="divButtom">
              <h1 style="margin-bottom: 5px">
                <span style="color: #7d8ba0">净利润达到5万元</span>
                <span style="float: right; color: #1890ff">0%</span>
              </h1>
              <el-progress :percentage="0" :stroke-width="4"></el-progress>
            </div>
          </div>
        </div>
      </div>
      <div class="profileLeft3">
        <h2 class="text-lg font-medium">等级专属模块</h2>
        <div v-for="(item, index) in moduleList" :key="index" class="div1">
          <div class="left3Header">
            <img :src="item.icon" alt="" />
            <span class="have-bought" v-if="item.is_has">已购买</span>
            <span class="spanButton" v-else>购买 ¥ {{ item.money }}</span>
          </div>

          <div class="left3Content">
            <h2>{{ item.title }}</h2>
            <div>{{ item.subtitle }}</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 实名 -->
    <IDCard v-if="isIdCard" @setCancel="setCancel" />
    <!-- 微信 -->
    <AccId v-if="isAccWxId" @setCancel="setCancel" />
    <!-- 邮箱 -->
    <Email v-if="isEmail" @setCancel="setCancel" />
    <!-- 支付宝 -->
    <AccAlipay v-if="isAcc_alipay" @setCancel="setCancel" />
    <!-- 手机 -->
    <AcPhone v-if="isPhone" @setCancel="setCancel" />

    <Enterprise v-if="isEnterprise" @setCancel="setCancel" />

    <!-- 头像昵称 -->
    <TouXiang v-if="isTouXiang" :info="userInfo" @setCancel="setCancel" />
    <!--    支付密码-->
    <zfPassword v-if="isPassword" :infoData="userInfo" @setCancel="setCancel" />
	<TechDesc v-if="isTech" :infoData="userInfo" @setCancel="setCancel" />
  </div>
</template>

<script>
import lodash from "lodash";
import request from "../utils/request";

import Cookies from "js-cookie";

import IDCard from "../modules/IDVerification";
import AccId from "../modules/accID";
import Email from "../modules/emailPop";

import AccAlipay from "../modules/AccAlipay";
import AcPhone from "../modules/AcPhone";
import Enterprise from "../modules/Enterprise";
import TouXiang from "../modules/TouXiang";
import zfPassword from "../modules/zfPassword";
import TechDesc from "../modules/TechDesc"

export default {
  components: {
    IDCard,
    AccId,
    Email,
    AccAlipay,
    AcPhone,
    Enterprise,
    TouXiang,
    zfPassword,
	TechDesc,
  },
  filters: {
    phoneFilter: function (phone) {
      if (phone) {
        return (
          String(phone).substring(0, 3) +
          "****" +
          String(phone).substring(7, 13)
        );
      } else {
        return "未绑定";
      }
    },

    emailFilter: function (email) {
      let i = email.indexOf("@");

      return "****";
    },
  },

  data: function () {
    return {
      is_Switch: true,
      isUserInfo: false,
      moduleList: [],
      isIdCard: false,
      isAccWxId: false,
      isEmail: false,
      isAcc_alipay: false,
      isPhone: false,
      isEnterprise: false,
      isTouXiang: false,
      isPassword: false,
      userInfo: null,
	  isTech: false,
    };
  },

  mounted: function () {
    this.userInfo = JSON.parse(Cookies.get("userInfo"));

    this.initModuleList();
  },

  computed: {
    discount: function () {
      return JSON.parse(Cookies.get("discount"));
    },

    growthValue: function () {
      console.log(this.discount.min_integral);
      console.log(this.discount.max_integral);

      if (this.discount.min_integral != 0 && this.discount.max_integral != 0) {
        return Number(
          (
            (Number(this.discount.min_integral) /
              Number(this.discount.max_integral)) *
            100
          ).toFixed(2)
        );
      } else {
        return 0;
      }
    },
  },

  methods: {
    setCancel: function (name, value) {
      if (name === "zfPassword") {
        this.isPassword = false;
        if (value) {
          this.userInfo.passcode = value;
        }
        return;
      }
      if (name === "isAccWxId") {
        this.isAccWxId = false;
        if (value) {
          this.userInfo.acc_wx_id = value;
        }
        return;
      }
      if (name === "Email") {
        this.isEmail = false;
        if (value) {
          this.userInfo.email = value;
        }
        return;
      }

      if (name === "Alipay") {
        this.isAcc_alipay = false;
        if (value) {
          this.userInfo.acc_alipay = value;
        }
        return;
      }

      if (name === "phone") {
        this.isPhone = false;
        if (value) {
          this.userInfo.phone = value;
        }
        return;
      }

      if (name === "IDVerification") {
        this.isIdCard = false;

        if (value) {
          this.getRefresh();
        }
        return;
      }

      if (name === "Enterprise") {
        this.isEnterprise = false;
        if (value) {
          this.getRefresh();
        }
        return;
      }

      if (name === "TouXiang") {
        this.isTouXiang = false;
        if (value) {
          this.getRefresh();
        }
        return;
      }
	  
	  if (name === "Tesc") {
	    this.isTech = false;
	    if (value) {
	      this.getRefresh();
	    }
	    return;
	  }
    },

    format(percentage) {
      return "信用良好";
    },

    initModuleList: function () {
      request({
        url: "/api/myApp/moduleList",
      }).then((res) => {
        res.data.forEach((item) => {
          let money = 0;
          let platform = item.platform.split(",");
          for (let i in platform) {
            money = money + Number(item[`cost_price_${platform[i]}`]);
          }
          item.money = money;
        });
        this.moduleList = res.data;
      });
    },

    // 获取初始数据， info
    onGetInfo: function () {
      request({
        url: "/api/sign/status",
        method: "POST",
      }).then((res) => {
        this.userInfo = res.data;
        Cookies.set("userInfo", res.data);
      });
      this.initModuleList();

      // console.log(this.userInfo)
    },

    // 刷新数据
    getRefresh: function () {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      setTimeout(() => {
        this.onGetInfo();
        loading.close();
      }, 400);
    },

    getUserInfo: lodash.throttle(function () {
      this.$message("装修中···");
    }, 500),
  },
};
</script>

<style lang="scss" scoped>
.profile-html {
  width: 100%;
  height: calc(100% - 80px);
  overflow: hidden;
  .profileBox {
    overflow: hidden;
    height: 100%;
    width: 100%;
    .profileLeft1 {
      white-space: nowrap;
      overflow: hidden;
      width: 23.5%;
      margin-right: 2%;
      float: left;
      position: relative;
      .header1 {
        width: 100%;
        margin: 20px 0;
        overflow: hidden;
        .truncate {
          float: left;
        }
        .switchRight {
          float: right;
        }
      }
      .text-theme-1 {
        font-size: 14px;
        float: right;
        height: 100%;
        margin-top: 5px;
      }
      .infoDiv {
        width: 100%;
        background: #ffffff;
        box-shadow: 0px 3px 20px rgba(0, 0, 0, 0.03);
        opacity: 1;
        border-radius: 22px;
        margin-bottom: 20px;
        .headDiv {
          height: 87px;
          width: 100%;
          box-sizing: border-box;
          border-bottom: 1px solid #f5f5f5;
          padding: 20px;

          .touXiang {
            width: 48px;
            height: 48px;
            border-radius: 50%;
            display: inline-block;
            vertical-align: middle;
            position: relative;
            .touXiang1 {
              border-radius: 50%;
              width: 100%;
              cursor: pointer;
            }
            .jiaobiao {
              position: absolute;
              right: 0;
              bottom: 0;
              z-index: 99;
            }
          }
          .headName {
            display: inline-block;
            line-height: 24px;
            margin-left: 5px;
            vertical-align: middle;
          }
        }
        .headDiv2 {
          height: 128px;
          width: 100%;
          box-sizing: border-box;
          border-bottom: 1px solid #f5f5f5;
          padding: 18px 20px;
          p {
            height: 30px;
            line-height: 30px;
            img {
              width: 16px;
              vertical-align: -2px;
              display: inline-block;
              margin-right: 10px;
            }
          }
        }
        .headDiv3 {
          width: 100%;
          padding: 18px 20px;
          box-sizing: border-box;
          border-bottom: 1px solid #f5f5f5;
		  overflow: hidden;
          p {
            img {
              width: 16px;
              vertical-align: -2px;
              display: inline-block;
              margin-right: 10px;
            }
            padding-bottom: 12px;
          }
        }
        .headDiv4 {
          display: none;
          height: 70px;
          width: 100%;
          color: #fff;
          padding: 20px;
          span {
            background: #1890ff;
            font-size: 14px;
            width: 87px;
            display: inline-block;
            text-align: center;
            height: 30px;
            line-height: 30px;
            border-radius: 7px;
            cursor: pointer;
          }
          .span:active {
            background: #389dfc;
          }
        }
      }
      .div2 {
        width: 100%;
        height: 185px;
        background: #ffffff;
        box-shadow: 0px 3px 20px rgba(0, 0, 0, 0.03);
        opacity: 1;
        border-radius: 22px;
        padding: 20px;
        position: relative;
        .contents {
          width: 318px;
          height: auto;
          font-size: 14px;
          color: #718096;
          white-space: normal !important;
        }
        .buttom-botton {
          width: 100%;
          overflow: hidden;
          margin-top: 20px;
          div {
            color: #718096;
            font-size: 14px;
            width: 68px;
            height: 31px;
            border-radius: 7px;
            text-align: center;
            line-height: 31px;
          }
        }
      }
    }
    .profileLeft2 {
      width: calc(100% - 25.5%);
      float: left;
      margin-bottom: 20px;

      .div1 {
        width: 24.6%;
        margin-right: 2.5%;
        max-width: 290px;
        float: left;
        padding-bottom: 20px;
        .list {
          margin: 5% auto;
          background: #f4f7f8;
          justify-content: space-between;
          border-radius: 2rem;
          position: relative;
          width: 90%;
          .button {
            position: absolute;
            top: 26%;
            right: 5%;
            width: 68px;
            height: 32px;
          }
          p {
            padding: 0 0 0 5%;
            line-height: 60px;
            font-size: 14px;
          }
          p:nth-child(2) {
            position: absolute;
            top: 30%;
            right: 15%;
            color: #1890ff;
            font-size: 20px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            line-height: 20px;
          }
          .tb {
            position: absolute;
            top: 33%;
            right: 7%;
            border-radius: 50%;
            width: 20px;
            height: 20px;
            background: #1890ff;
            color: #fff;
            text-align: center;
            line-height: 20px;
            cursor: pointer;
          }
        }
        .infoBgPng {
          height: 150px;
          width: 90%;
          box-sizing: border-box;
          padding: 16px;
          position: relative;
          margin: 20px auto 0;
          background: linear-gradient(
            89deg,
            #18d3ff 0%,
            #8934ff 51%,
            #ff5252 100%
          );
          box-shadow: 0px 10px 20px rgba(60, 132, 204, 0.43);

          border-radius: 15px;

          // background-image: url("../assets/images/infoBg.png");
          // background-repeat: no-repeat;
          // background-size: 100% 100%;
          .infoHead {
            overflow: hidden;
            .infoHead-img {
              height: 23px;
              width: 23px;
              float: left;
              margin: 3px 3px 0 0;
            }
            .div-p {
              color: #fff;
              font-size: 12px;
              float: left;
            }
          }
          .infoName {
            color: #fff;
            font-size: 16px;
            line-height: 20px;
            margin-top: 22px;
          }

          .infoID {
            color: #ffffff;
            font-size: 12px;
            height: 22px;
            margin-top: 22px;

            .kaiguan {
              float: right;
              vertical-align: middle;
            }
          }
        }

        .infoButtom-box {
          padding: 9px 20px 0;
          width: 100%;
          box-sizing: border-box;
          div {
            width: 100%;
            height: 50px;
            background: #eef2f7;
            line-height: 50px;
            font-size: 14px;
            color: #718096;
            border-radius: 22px;
            padding: 0 20px;
            .wenhao::after {
              content: "?";
              border-radius: 50%;
              width: 16px;
              display: inline-block;
              vertical-align: 0px;
              height: 16px;
              background: #1890ff;
              padding: 1px;
              color: #fff;
              text-align: center;
              line-height: 16px;
              margin-left: 5px;
              font-size: 12px;
              vertical-align: 3px;
            }
          }
        }

        .buttomTitle {
          color: #607f96;
          font-size: 14px;
          width: 100%;
          text-align: center;
          margin-top: 45px;
        }

        .header2 {
          width: 100%;
          overflow: hidden;
          color: #2d3748;
          font-size: 18px;
          padding: 20px 0;
        }
        .div1 {
          min-height: 447px;

          background: #ffffff;
          box-shadow: 0px 3px 20px rgba(0, 0, 0, 0.03);
          width: 100%;
          border-radius: 22px;
        }
      }
      .div2 {
        width: calc(100% - 27.1%);
        min-height: 447px;
        float: left;

        .header3 {
          width: 100%;
          overflow: hidden;
          padding: 20px 0;
          .title {
            float: left;
            font-size: 18px;
            color: #2d3748;
          }
          .text-theme-1 {
            float: right;
            margin-top: 5px;
            cursor: pointer;
          }
        }
        .p1 {
          width: 97%;
          overflow: hidden;
          background: #ffffff;
          box-shadow: 0px 3px 20px rgba(0, 0, 0, 0.03);
          opacity: 1;
          border-radius: 22px;
          margin-bottom: 20px;
          .div1 {
            height: 64px;
            box-sizing: border-box;
            border-bottom: 1px solid #f5f5f5;
            color: #2d3748;
            font-size: 18px;
            padding: 20px;
            width: 100%;
          }
          .divButtom {
            font-size: 14px;
            height: 75px;
            box-sizing: border-box;
            width: 100%;
            overflow: hidden;
            padding: 20px;
          }
        }
      }
    }
    .profileLeft3 {
      min-height: 200px;
      width: calc(100% - 25.5%);

      float: left;
      .font-medium {
        padding-bottom: 20px;
      }
      .div1 {
        width: 22.5%;
        height: 214px;
        background: #ffffff;
        box-shadow: 0px 3px 20px rgba(0, 0, 0, 0.03);
        opacity: 1;
        border-radius: 22px;
        margin-right: 2.5%;
        float: left;
        margin-bottom: 20px;
        padding: 20px;
        .left3Header {
          img {
            height: 83px;
            width: 83px;
            display: inline-block;
            border-radius: 20px;
          }

          .have-bought {
            padding: 2px 12px;
            background: #edf2f7;
            color: #718096;
            font-size: 14px;
            border-radius: 7px;
            vertical-align: bottom;
            float: right;
            margin-top: 60px;
          }
          .spanButton {
            padding: 2px 12px;
            background: #1890ff;
            color: #fff;
            font-size: 14px;
            border-radius: 7px;
            vertical-align: bottom;
            float: right;
            margin-top: 60px;
          }

          .spanButton:active {
            background: rgb(61, 154, 241);
          }
        }
        .left3Content {
          width: 100%;
          margin-top: 20px;
          h2 {
            color: #2d3748;
            font-size: 16px;
            margin-bottom: 5px;
          }
          div {
            color: #718096;
            font-size: 14px;
          }
        }
      }
      .div1:nth-child(4n + 1) {
        margin-right: 0;
      }
    }
  }
}

.conceal-a {
  overflow: hidden;
  display: none;
  .div1 {
    width: 100% !important;
  }
}

.xinyongfen1 {
  height: 100%;
  float: left;

  h1 {
    color: #1890ff;
    font-size: 30px;
    margin-top: 5%;
  }
  h2 {
    color: #2d3748;
    font-size: 16px;
    margin-top: 20%;
  }
  h3 {
    color: #a0aec0;
    font-size: 14px;
  }

  .div1 {
    display: none;
    margin-top: 10px;
    width: 87px;
    height: 31px;
    background: #edf2f7;
    border-radius: 7px;
    text-align: center;
    line-height: 31px;
    color: #718096;
    font-size: 14px;
    cursor: pointer;
  }

  .div1:active {
    background: #dce7f1;
  }
}

.xinyongfen2 {
  position: absolute;
  right: 15px;
  top: 0;
  bottom: 0;
  margin: auto 0;
  width: 126px;
  height: 126px;
}

.amendClass {
  cursor: pointer;
  color: #1890ff;

  font-size: 14px;
}

.xinpian {
  float: right;
}

@media screen and (max-width: 1899px) {
  .profileBox .profileLeft1 {
    width: 27.5% !important;
  }

  .profileBox .profileLeft3 {
    width: 100% !important;
  }
  .profile-html .profileBox .profileLeft2 {
    width: 70% !important;
  }

  .profile-html .profileBox .profileLeft2 .div1 {
    width: 98%;
  }
  .profile-html .profileBox .profileLeft2 .div2 {
    width: 100%;
  }
}

@media screen and (max-width: 1900px) {
  .profile-html .profileBox .profileLeft2 {
    width: 63% !important;
  }
  .profile-html .profileBox .profileLeft1 {
    width: 35% !important;
  }
  .profile-html .profileBox .profileLeft2 .div1 {
    width: 98% !important;
    display: none;
  }
  .profile-html .profileBox .profileLeft2 .div2 {
    width: 100% !important;
    min-height: auto !important;
  }

  .profileBox .profileLeft3 {
    width: 63% !important;
    .div1 {
      width: 47.5% !important;
    }
  }

  .conceal-a {
    display: block !important;
  }

  .profile-html .profileBox .conceal-a {
    width: 100% !important;
    margin-top: 10px;
  }

  .profile-html .profileBox .conceal-a .div1 {
    display: block;
    max-width: none !important;
    width: 100% !important;
    background: "" !important;
  }
}

@media screen and (max-width: 600px) {
  .profile-html .profileBox .profileLeft1 {
    width: 100% !important;
  }
  .profile-html .profileBox .profileLeft2 {
    width: 100% !important;
  }
  .profile-html .profileBox .profileLeft3 {
    width: 100% !important;
  }
  .profileBox .profileLeft3 .div1 {
    width: 100% !important;
  }
  .profile-html .profileBox .profileLeft2 .div2 .p1 {
    width: 100% !important;
  }
  .profile-html .profileBox .profileLeft2 .div1 .infoBgPng {
    height: 220px !important;
  }
}
</style>